import type { StateCreator } from 'zustand';
import type { Session } from '@supabase/supabase-js';
import type { UserProfile } from '@/types';
import { supabase } from '@/lib/supabase';
import { logAction } from '@/services/auditLog.service';
import { AuditLogAction, AuditLogEntityType } from '@/types/audit-log.types';

/**
 * Auth Slice - Gestion de l'authentification
 */
export interface AuthSlice {
  session: Session | null;
  profile: UserProfile | null;
  loading: boolean;
  setSession: (session: Session | null) => void;
  setProfile: (profile: UserProfile | null) => void;
  setLoading: (loading: boolean) => void;
  signOut: () => Promise<void>;
}

export const createAuthSlice: StateCreator<AuthSlice> = (set) => ({
  session: null,
  profile: null,
  loading: true,

  setSession: (session) => set({ session }),

  setProfile: (profile) => set({ profile }),

  setLoading: (loading) => set({ loading }),

  signOut: async () => {
    // Log l'action de déconnexion avant de se déconnecter
    try {
      await logAction({
        action: AuditLogAction.LOGOUT,
        entity_type: AuditLogEntityType.SYSTEM,
        details: 'Déconnexion utilisateur',
      });
    } catch (error) {
      console.error('Error logging logout action:', error);
    }

    await supabase.auth.signOut();
    set({ session: null, profile: null });
  },
});
